/** Badge «Atualizado recentemente» — janela de 14 dias. */

export const RECENTLY_UPDATED_DAYS = 14;

export function isRecentlyUpdated(
  updatedAt?: string | null,
  publishedAt?: string | null
): boolean {
  const raw = updatedAt || publishedAt;
  if (!raw) return false;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return false;
  const windowMs = RECENTLY_UPDATED_DAYS * 24 * 60 * 60 * 1000;
  return Date.now() - date.getTime() <= windowMs;
}
